/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type { ElementType } from "react";
import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { Link } from "react-router-dom";

export default function DashboardCard({
  label,
  Icon,
  value,
  status,
  fontClass,
  tooltip,
  filters,
  disabled,
}: {
  label: string;
  value: string;
  status: string;
  Icon: ElementType;
  fontClass?: any;
  tooltip?: string;
  disabled?: boolean;
  filters?: any;
}) {
  const getRedirectURL = () => {
    let redirectString = `title=${label}&status=${status}`;
    if (filters?.assignmentGroup?.id) {
      redirectString = `${redirectString}&assignmentGroup=${filters.assignmentGroup.id}`;
    }
    if (filters?.account?.id) {
      redirectString = `${redirectString}&accountId=${filters.account.id}`;
    }
    if (filters?.region?.id) {
      redirectString = `${redirectString}&region=${filters.region.id}`;
    }
    if (filters?.date?.id) {
      redirectString = `${redirectString}&period=${filters.date.id}`;
    }
    if (filters?.loggedToday) {
      redirectString = `${redirectString}&loggedToday=Yes`;
    }
    if (filters?.carriedOverCalls) {
      redirectString = `${redirectString}&carriedOverCalls=Yes`;
    }
    if (filters?.vaultAccessRequired) {
      redirectString = `${redirectString}&vaultAccessRequired=Yes`;
    }
    return redirectString;
  };
  return (
    <Card title={tooltip} className="h-[12em] relative">
      <Link to={disabled ? "" : `/dashboard-detail?${getRedirectURL()}`}>
        <CardHeader
          className="p-0 rounded-[0.5rem 0.5rem 0px 0px] absolute top-0 left-0"
          style={{ borderRadius: "0.5rem 0.5rem 0px 0px" }}
        >
          <CardTitle className="text-md p-[0.5em]">{label}</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center p-[0.5em] h-full py-0">
          <div className="flex-1 flex-col">
            <p
              className={
                fontClass ? fontClass : "text-3xl text-secondary text-center"
              }
            >
              {value}
            </p>
          </div>

          {/* <Icon size="25px" /> */}
        </CardContent>
      </Link>
    </Card>
  );
}
